import { SolNavbar, SolNavbarItem, SolRouteId } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

const moduleItem = (
  listRouteId: SolRouteId,
  detailRouteId: SolRouteId,
  overviewRouteId: SolRouteId,
  activityRouteId: SolRouteId,
  displayName: string,
  icon: SolIcon,
): SolNavbarItem =>
  SolNavbarItem.of(listRouteId, {
    displayName,
    icon,
    showChildrenInNavbar: false,
    children: [
      SolNavbarItem.of(detailRouteId, {
        displayName: 'asm-prototype.webcontent-v2.content.name',
        nameParams: ['contentName'],
        showChildrenAsTabs: true,
        children: [
          SolNavbarItem.of(overviewRouteId, { displayName: 'Overview' }),
          SolNavbarItem.of(activityRouteId, { displayName: 'Activity' }),
        ],
      }),
    ],
  });

export const webcontentV2Navbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.webcontent_v2_drp, {
      displayName: 'Digital Risk Protection',
      icon: SolIcon.asm_drp,
      children: [
        moduleItem(
          PrototypeRouteId.webcontent_v2_dark_web,
          PrototypeRouteId.webcontent_v2_dark_web_detail,
          PrototypeRouteId.webcontent_v2_dark_web_detail_overview,
          PrototypeRouteId.webcontent_v2_dark_web_detail_activity,
          'Dark Web',
          SolIcon.asm_dark_web,
        ),
        moduleItem(
          PrototypeRouteId.webcontent_v2_data_leakage,
          PrototypeRouteId.webcontent_v2_data_leakage_detail,
          PrototypeRouteId.webcontent_v2_data_leakage_detail_overview,
          PrototypeRouteId.webcontent_v2_data_leakage_detail_activity,
          'Data Leakage',
          SolIcon.asm_data_leakage,
        ),
        moduleItem(
          PrototypeRouteId.webcontent_v2_social_media,
          PrototypeRouteId.webcontent_v2_social_media_detail,
          PrototypeRouteId.webcontent_v2_social_media_detail_overview,
          PrototypeRouteId.webcontent_v2_social_media_detail_activity,
          'Social Media',
          SolIcon.asm_social_media,
        ),
        moduleItem(
          PrototypeRouteId.webcontent_v2_mobile_apps,
          PrototypeRouteId.webcontent_v2_mobile_app_detail,
          PrototypeRouteId.webcontent_v2_mobile_app_detail_overview,
          PrototypeRouteId.webcontent_v2_mobile_app_detail_activity,
          'Mobile Apps',
          SolIcon.asm_mobile_apps,
        ),
      ],
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
